import React, { useContext, useEffect, useState } from "react";
import "./style/Basket.css";
import { BasketContext } from "../components/context/Context";
import BasketCard from "../components/cards/BasketCard";
import empty from "../imgs/empty-01.svg";

function Basket() {
  const [basket, setBasket] = useContext(BasketContext);

  return (
    <div className="basket">
      {!basket.length ? (
        <>
          <img src={empty} alt="empty basket" className="empty" />
          <span>Your Basket is empty !!!</span>
        </>
      ) : (
        basket?.map((item) => {
          return (
            <BasketCard
              key={item.id}
              id={item.id}
              src={item.src}
              title={item.title}
              prix={item.prix}
              desc={item.desc}
              rating={item.rating}
            />
          );
        })
      )}
    </div>
  );
}

export default Basket;
